import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
const phoneConfigs = {
    ru: {
        code: '+7',
        mask: '(___) ___-__-__',
        localDigits: 10,
        format: (d) => {
            const p = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 8), d.slice(8, 10)].filter(Boolean);
            const [a, b, c, e] = p;
            if (!a)
                return '';
            if (!b)
                return `(${a}`;
            if (!c)
                return `(${a}) ${b}`;
            if (!e)
                return `(${a}) ${b}-${c}`;
            return `(${a}) ${b}-${c}-${e}`;
        },
    },
    us: {
        code: '+1',
        mask: '(___) ___-____',
        localDigits: 10,
        format: (d) => {
            const [a, b, c] = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 10)].filter(Boolean);
            if (!a)
                return '';
            if (!b)
                return `(${a}`;
            if (!c)
                return `(${a}) ${b}`;
            return `(${a}) ${b}-${c}`;
        },
    },
    ca: {
        code: '+1',
        mask: '(___) ___-____',
        localDigits: 10,
        format: (d) => {
            const [a, b, c] = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 10)].filter(Boolean);
            if (!a)
                return '';
            if (!b)
                return `(${a}`;
            if (!c)
                return `(${a}) ${b}`;
            return `(${a}) ${b}-${c}`;
        },
    },
    de: {
        code: '+49',
        mask: '___ ________',
        localDigits: 11, // немецкие номера от 10 до 11 цифр
        format: (d) => {
            const [a, b] = [d.slice(0, 3), d.slice(3)].filter(Boolean);
            if (!a)
                return '';
            if (!b)
                return a;
            return `${a} ${b}`;
        },
    },
};
/* ========== COMPONENT ========== */
export const LeadForm = ({ onSubmit, onClose, title = '', subtitle = '', questions = [], lang = 'en', country = 'us', }) => {
    const [name, setName] = useState('');
    const [localPhone, setLocalPhone] = useState(''); // только цифры без кода
    const [answers, setAnswers] = useState(() => Object.fromEntries(questions.map(q => [q.id, q.type === 'checkbox' ? [] : ''])));
    const [state, setState] = useState('idle');
    const [errors, setErrors] = useState({});
    const cfg = phoneConfigs[country];
    const handlePhoneChange = (raw) => {
        // оставляем только цифры, режем по максимуму
        const digits = raw.replace(/\D/g, '').slice(0, cfg.localDigits);
        setLocalPhone(digits);
        if (errors.phone)
            setErrors(p => ({ ...p, phone: '' }));
    };
    const formattedPhone = cfg.format(localPhone);
    const fullPhone = localPhone ? `${cfg.code} ${formattedPhone}` : '';
    const validate = () => {
        const newErrors = {};
        if (!name.trim() || name.trim().length < 2)
            newErrors.name = locale[lang]['enterNameMin2'];
        if (localPhone.length < cfg.localDigits)
            newErrors.phone = locale[lang]['enterValidPhone'];
        questions.forEach(q => {
            if (!q.required)
                return;
            const val = answers[q.id];
            if (q.type === 'checkbox') {
                if (val.length === 0)
                    newErrors[q.id] = locale[lang]['selectAtLeastOne'];
            }
            else {
                if (!val.trim())
                    newErrors[q.id] = locale[lang]['requiredField'];
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleCheckbox = (id, option, checked) => {
        setAnswers(prev => {
            const current = prev[id] ?? [];
            return {
                ...prev,
                [id]: checked ? [...current, option] : current.filter(v => v !== option),
            };
        });
        if (errors[id])
            setErrors(prev => ({ ...prev, [id]: '' }));
    };
    const handleText = (id, value) => {
        setAnswers(prev => ({ ...prev, [id]: value }));
        if (errors[id])
            setErrors(prev => ({ ...prev, [id]: '' }));
    };
    const handleSelect = (id, value) => {
        setAnswers(prev => ({ ...prev, [id]: value }));
        if (errors[id])
            setErrors(prev => ({ ...prev, [id]: '' }));
    };
    const handleSubmit = async () => {
        if (!validate())
            return;
        setState('loading');
        try {
            await onSubmit({ name: name.trim(), phone: fullPhone, answers });
            setState('success');
        }
        catch {
            setState('error');
        }
    };
    const inputStyle = (hasError) => ({
        width: '100%',
        padding: '10px 12px',
        borderRadius: 8,
        border: `1.5px solid ${hasError ? '#e53e3e' : '#e2e8f0'}`,
        fontSize: 14,
        outline: 'none',
        boxSizing: 'border-box',
        background: '#fff',
        color: '#1a202c',
    });
    if (state === 'success') {
        return (_jsx("div", { style: overlayStyle, children: _jsxs("div", { style: cardStyle, children: [onClose && _jsx(CloseButton, { onClick: onClose }), _jsxs("div", { style: { textAlign: 'center', padding: '12px 0' }, children: [_jsx("div", { style: { fontSize: 48, marginBottom: 12 }, children: "\u2713" }), _jsx("div", { style: { fontWeight: 700, fontSize: 18, color: '#1a202c', marginBottom: 6 }, children: locale[lang]['requestSent'] }), _jsx("div", { style: { color: '#718096', fontSize: 14 }, children: locale[lang]['contactSoon'] })] })] }) }));
    }
    return (_jsx("div", { style: overlayStyle, children: _jsxs("div", { style: cardStyle, onKeyDown: e => e.key === 'Enter' && handleSubmit(), children: [onClose && _jsx(CloseButton, { onClick: onClose }), _jsxs("div", { style: { marginBottom: 20 }, children: [_jsx("div", { style: { fontWeight: 700, fontSize: 18, color: '#1a202c', marginBottom: 4 }, children: title || locale[lang]['leaveRequest'] }), _jsx("div", { style: { color: '#718096', fontSize: 13 }, children: subtitle || locale[lang]['contactSoon'] })] }), _jsxs("div", { style: { marginBottom: 14 }, children: [_jsx("label", { style: labelStyle, children: locale[lang]['name'] }), _jsx("input", { type: "text", placeholder: locale[lang]['yourName'], value: name, onChange: e => { setName(e.target.value); if (errors.name)
                                setErrors(p => ({ ...p, name: '' })); }, style: inputStyle(!!errors.name), disabled: state === 'loading' }), errors.name && _jsx("div", { style: errorStyle, children: errors.name })] }), _jsxs("div", { style: { marginBottom: 20 }, children: [_jsx("label", { style: labelStyle, children: locale[lang]['phone'] }), _jsxs("div", { style: { display: 'flex', gap: 8, alignItems: 'center' }, children: [_jsx("div", { style: {
                                        padding: '10px 12px',
                                        borderRadius: 8,
                                        border: '1.5px solid #e2e8f0',
                                        fontSize: 14,
                                        background: '#f7fafc',
                                        color: '#4a5568',
                                        whiteSpace: 'nowrap',
                                        fontWeight: 600,
                                        flexShrink: 0,
                                    }, children: cfg.code }), _jsx("div", { style: { flex: 1, position: 'relative' }, children: _jsx("input", { type: "tel", placeholder: cfg.mask, value: formattedPhone, onChange: e => handlePhoneChange(e.target.value), style: inputStyle(!!errors.phone), disabled: state === 'loading' }) })] }), errors.phone && _jsx("div", { style: errorStyle, children: errors.phone })] }), questions.map(q => (_jsxs("div", { style: { marginBottom: 16 }, children: [_jsxs("label", { style: labelStyle, children: [q.label, q.required && _jsx("span", { style: { color: '#e53e3e', marginLeft: 3 }, children: "*" })] }), q.type === 'text' && (_jsx("input", { type: "text", placeholder: q.placeholder ?? '', value: answers[q.id] ?? '', onChange: e => handleText(q.id, e.target.value), style: inputStyle(!!errors[q.id]), disabled: state === 'loading' })), q.type === 'select' && (_jsxs("select", { value: answers[q.id] ?? '', onChange: e => handleSelect(q.id, e.target.value), disabled: state === 'loading', style: { ...inputStyle(!!errors[q.id]), appearance: 'auto' }, children: [_jsx("option", { value: "", children: locale[lang]['selectPlaceholder'] }), q.options?.map(opt => (_jsx("option", { value: opt, children: opt }, opt)))] })), q.type === 'checkbox' && (_jsx("div", { style: { display: 'flex', flexDirection: 'column', gap: 8 }, children: q.options?.map(opt => {
                                const checked = (answers[q.id] ?? []).includes(opt);
                                return (_jsxs("label", { style: {
                                        display: 'flex', alignItems: 'center', gap: 8,
                                        fontSize: 13, color: '#2d3748', cursor: 'pointer',
                                    }, children: [_jsx("input", { type: "checkbox", checked: checked, onChange: e => handleCheckbox(q.id, opt, e.target.checked), disabled: state === 'loading', style: { width: 15, height: 15, cursor: 'pointer', accentColor: '#2d3748' } }), opt] }, opt));
                            }) })), errors[q.id] && _jsx("div", { style: errorStyle, children: errors[q.id] })] }, q.id))), state === 'error' && (_jsx("div", { style: {
                        background: '#fff5f5', border: '1px solid #fed7d7',
                        borderRadius: 8, padding: '10px 12px',
                        color: '#c53030', fontSize: 13, marginBottom: 14,
                    }, children: locale[lang]['sendError'] })), _jsx("button", { onClick: handleSubmit, disabled: state === 'loading', style: {
                        width: '100%', padding: '11px', borderRadius: 8,
                        border: 'none', background: state === 'loading' ? '#a0aec0' : '#2d3748',
                        color: '#fff', fontWeight: 600, fontSize: 14,
                        cursor: state === 'loading' ? 'not-allowed' : 'pointer',
                    }, children: state === 'loading' ? locale[lang]['sending'] : locale[lang]['send'] })] }) }));
};
const CloseButton = ({ onClick }) => (_jsx("div", { onClick: onClick, style: {
        position: 'absolute', top: 12, right: 14, cursor: 'pointer',
        color: '#a0aec0', fontSize: 18, lineHeight: 1, userSelect: 'none',
    }, children: "\u2715" }));
const overlayStyle = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
};
const cardStyle = {
    position: 'relative', background: '#fff', borderRadius: 14,
    padding: '28px 28px 24px', width: 340,
    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    maxHeight: '90vh', overflowY: 'auto',
};
const labelStyle = {
    display: 'block', fontSize: 13, fontWeight: 600, color: '#4a5568', marginBottom: 6,
};
const errorStyle = { color: '#e53e3e', fontSize: 12, marginTop: 4 };
const locale = {
    ru: {
        leaveRequest: 'Оставить заявку',
        contactSoon: 'Мы свяжемся с вами в ближайшее время',
        enterNameMin2: 'Введите имя (минимум 2 символа)',
        enterValidPhone: 'Введите корректный номер телефона',
        selectAtLeastOne: 'Выберите хотя бы один вариант',
        requiredField: 'Обязательное поле',
        requestSent: 'Заявка отправлена!',
        yourName: 'Ваше имя',
        name: 'Имя',
        phone: 'Телефон',
        selectPlaceholder: '— выберите —',
        sendError: 'Ошибка отправки. Попробуйте ещё раз позже.',
        sending: 'Отправка...',
        send: 'Отправить',
    },
    en: {
        leaveRequest: 'Submit a request',
        contactSoon: 'We\'ll contact you shortly',
        enterNameMin2: 'Enter a name (at least 2 characters)',
        enterValidPhone: 'Enter a valid phone number',
        selectAtLeastOne: 'Select at least one option',
        requiredField: 'Required field',
        requestSent: 'Request sent!',
        yourName: 'Your name',
        name: 'Name',
        phone: 'Phone',
        selectPlaceholder: '— select —',
        sendError: 'Sending failed. Please try again later.',
        sending: 'Sending...',
        send: 'Send',
    },
    de: {
        leaveRequest: 'Anfrage senden',
        contactSoon: 'Wir melden uns in Kürze bei Ihnen',
        enterNameMin2: 'Geben Sie einen Namen ein (mindestens 2 Zeichen)',
        enterValidPhone: 'Geben Sie eine gültige Telefonnummer ein',
        selectAtLeastOne: 'Wählen Sie mindestens eine Option aus',
        requiredField: 'Pflichtfeld',
        requestSent: 'Anfrage gesendet!',
        yourName: 'Ihr Name',
        name: 'Name',
        phone: 'Telefon',
        selectPlaceholder: '— auswählen —',
        sendError: 'Fehler beim Senden. Bitte versuchen Sie es später erneut.',
        sending: 'Wird gesendet...',
        send: 'Senden',
    },
};
